import CryptoJS from 'crypto-js'

// Shared AES-CBC settings used to encrypt the company code that is embedded in
// the Android Enterprise provisioning QR payload. The Android MyDevice app must
// decrypt the `companyCode` value with the EXACT same key, IV, mode (CBC) and
// PKCS7 padding, then Base64-decode the ciphertext.
//
// The key is a raw 32-byte (AES-256) UTF-8 value and the IV is a raw 16-byte
// UTF-8 value. Because the key is provided as a WordArray (not a passphrase),
// crypto-js performs plain AES-CBC with no OpenSSL salt header, which keeps the
// output trivially decryptable by javax.crypto on Android.
//
// NOTE: this is a hardcoded shared constant, so it is obfuscation-grade, not
// secret-grade — anyone can read the bundled frontend source.
const COMPANY_CODE_AES_KEY = CryptoJS.enc.Utf8.parse('Mydev1ceQrPr0v1si0n1ngK3y2024!@#')
const COMPANY_CODE_AES_IV = CryptoJS.enc.Utf8.parse('MyDev1ceQrIV2024')

const COMPANY_CODE_CIPHER_OPTIONS = {
  iv: COMPANY_CODE_AES_IV,
  mode: CryptoJS.mode.CBC,
  padding: CryptoJS.pad.Pkcs7,
}

// Encrypt a company code for the provisioning QR. Returns a Base64 string, or an
// empty string when there is nothing to encrypt.
export const encryptCompanyCode = (companyCode) => {
  const value = String(companyCode || '').trim()

  if (!value) {
    return ''
  }

  return CryptoJS.AES.encrypt(value, COMPANY_CODE_AES_KEY, COMPANY_CODE_CIPHER_OPTIONS).toString()
}

// Decrypt a company code produced by encryptCompanyCode (mainly for tests and
// for symmetry with the Android side). Returns an empty string on failure.
export const decryptCompanyCode = (encryptedCompanyCode) => {
  const value = String(encryptedCompanyCode || '').trim()

  if (!value) {
    return ''
  }

  try {
    return CryptoJS.AES.decrypt(value, COMPANY_CODE_AES_KEY, COMPANY_CODE_CIPHER_OPTIONS).toString(CryptoJS.enc.Utf8)
  } catch (error) {
    return ''
  }
}
